export enum FlowStatusEnum {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export const FlowStatusLabels = {
  [FlowStatusEnum.ACTIVE]: 'Ativo',
  [FlowStatusEnum.INACTIVE]: 'Inativo',
}